import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Button} from "reactstrap"
import {message} from 'antd'
import {getExportOrdersCSVv41} from "../../../services/api/apiBarcode"
import moment from 'moment'
import {runExportJob, isExporting, subscribeExporting} from '../../helpers/runExportJob'

function cleanObjectShallow(obj) {
  return Object.fromEntries(
    Object.entries(obj).filter(([_, v]) =>
      !(v === "" || v === null || v === undefined || (Array.isArray(v) && v.length === 0))
    )
  )
}

const EXPORT_KEY = 'list-items:export-orders'

class ExportOrders extends Component {
    // `exporting` DERIVE từ khoá in-flight cấp module, không tự quản lý riêng.
    // Lý do: khoá sống theo tab còn state sống theo instance. Component này unmount khi đổi
    // route, và request có thể bay tới 60s (EXPORT_JOB_TIMEOUT) — nếu giữ state riêng thì lúc
    // user quay lại, instance mới có `exporting = false` và nút trông như sẵn sàng, bấm vào
    // chỉ nhận toast "đang tạo job" mà không có gì xảy ra.
    // Derive cũng loại luôn `setState` sau unmount: unsubscribe trong componentWillUnmount là
    // đường setState duy nhất, nên không còn cảnh báo "state update on unmounted component".
    state = {
        exporting: isExporting(EXPORT_KEY),
    }

    componentDidMount() {
        this._unsubscribeExporting = subscribeExporting(() => {
            this.setState({exporting: isExporting(EXPORT_KEY)})
        })
        // Khoá có thể đã đổi giữa lúc khởi tạo state và lúc mount xong
        this.setState({exporting: isExporting(EXPORT_KEY)})
    }

    componentWillUnmount() {
        if (this._unsubscribeExporting) this._unsubscribeExporting()
    }

    _exportOrders = async () => {
        if (this.state.exporting) return

        try {
            const {filter} = this.props

            let tagsExport = []
            if(filter.tags)  tagsExport.push(...filter.tags)
            if(filter.list_tags) tagsExport.push(...filter.list_tags)

            const filterTags = {
                tags: tagsExport
            }
            
            const {list_tags, tags, ...rest} = filter

            const cloneFilterExp = Object.assign({}, rest, filterTags)

            delete cloneFilterExp['created']
            delete cloneFilterExp['generated']
            delete cloneFilterExp['barcodeNumber']

            if (filter.created.hasOwnProperty('from')) {
                cloneFilterExp['created[from]'] = filter.created.from
            }

            if (filter.created.hasOwnProperty('to')) {
                cloneFilterExp['created[to]'] = filter.created.to
            }

            if (filter.generated.hasOwnProperty('from')) {
                cloneFilterExp['generated[from]'] = filter.generated.from
            }

            if (filter.generated.hasOwnProperty('to')) {
                cloneFilterExp['generated[to]'] = filter.generated.to
            }

            if (filter.barcodeNumber.hasOwnProperty('$gte')) {
                cloneFilterExp['barcodeNumber[$gte]'] = filter.barcodeNumber['$gte']
            }

            if (filter.barcodeNumber.hasOwnProperty('$lte')) {
                cloneFilterExp['barcodeNumber[$lte]'] = filter.barcodeNumber['$lte']
            }

            if (filter.hasOwnProperty('generate_label_config.delay_days')) {
                if (filter['generate_label_config.delay_days'].hasOwnProperty('from')) {
                    cloneFilterExp['generate_label_config.delay_days[from]'] = filter['generate_label_config.delay_days'].from
                    delete cloneFilterExp['generate_label_config.delay_days']
                }

                if (filter['generate_label_config.delay_days'].hasOwnProperty('to')) {
                    cloneFilterExp['generate_label_config.delay_days[to]'] = filter['generate_label_config.delay_days'].to
                    delete cloneFilterExp['generate_label_config.delay_days']
                }
            }

            if(filter.is_fba) {
                if(filter.is_fba === 'TikTok'){
                    cloneFilterExp.is_tiktok = 'y'
                    delete cloneFilterExp.is_fba
                }else if(filter.is_fba === 'n'){
                    cloneFilterExp.is_tiktok = 'n'
                }
            }
            
            if (filter.hasOwnProperty('products.overtimeLte')) {
                cloneFilterExp['products.overtime[$lte]'] = parseFloat(filter['products.overtimeLte'])
                delete cloneFilterExp['products.overtimeLte']
            }
        
            if (filter.hasOwnProperty('products.overtimeGt')) {
                cloneFilterExp['products.overtime[$gt]'] = parseFloat(filter['products.overtimeGt'])
                delete cloneFilterExp['products.overtimeGt']
            }
            
            if(cloneFilterExp.photo_requested) cloneFilterExp.request_photo_statuses = [cloneFilterExp.photo_requested]
            
            const cleanFilter = cleanObjectShallow({...cloneFilterExp})

            await runExportJob(
                EXPORT_KEY,
                () => getExportOrdersCSVv41({...cleanFilter}),
                {filename: `Orders-${moment().format('YYYY-MM-DD')}.csv`}
            )
        } catch (e) {
            // `runExportJob` tự báo lỗi và không reject; nhánh này chỉ còn bắt lỗi phát sinh
            // khi dựng payload ở trên (vd `filter.created` undefined).
            message.error(e.message || e.toString())
        }
    }

    render() {
        const {exporting} = this.state

        return (
            <Button
                className="btn-labeled btn-labeled-left"
                onClick={this._exportOrders}
                color="primary"
                disabled={exporting}
            >
                <b><i className={exporting ? 'fa fa-spinner fa-spin' : 'mi-cloud-upload'}/></b>
                {exporting ? 'Exporting' : 'Export Orders'}
            </Button>
        )
    }
}

ExportOrders.propTypes = {
    filter: PropTypes.object.isRequired
}

export default ExportOrders
